import { render, staticRenderFns } from "./GenericLikeButton.vue?vue&type=template&id=39cc392c&scoped=true"
import script from "./GenericLikeButton.vue?vue&type=script&lang=js"
export * from "./GenericLikeButton.vue?vue&type=script&lang=js"
import style0 from "./GenericLikeButton.vue?vue&type=style&index=0&id=39cc392c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc392c",
  null
  
)

export default component.exports